import { Language } from "../types/language";
import { useFeatureServices } from "../use-feature-services";

const useGetLang = () => {

    const lang = useFeatureServices()['locale-service'].language as Language;

    return lang;
}

export default useGetLang;